import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
});

export const setAuthHeader = (token) => {
  if (token) {
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    localStorage.setItem("lecis_admin_token", token);
  } else {
    delete api.defaults.headers.common["Authorization"];
    localStorage.removeItem("lecis_admin_token");
  }
};

// Restore token from storage on startup
const existing = typeof window !== "undefined" ? localStorage.getItem("lecis_admin_token") : null;
if (existing) {
  api.defaults.headers.common["Authorization"] = `Bearer ${existing}`;
}

// Session-expiry handler: when an admin-area request 401s (expired/invalid
// token), clear the token and bounce to the login page with a friendly note.
// Guards prevent: (a) redirecting storefront/public 401s, (b) intercepting the
// login attempt's own 401 (wrong password), and (c) redirect loops.
let _redirecting = false;
api.interceptors.response.use(
  (resp) => resp,
  (error) => {
    const status = error?.response?.status;
    const url = error?.config?.url || "";
    if (status === 401 && typeof window !== "undefined" && !_redirecting) {
      const path = window.location.pathname;
      const onAdmin = path.startsWith("/admin");
      const onLogin = path.startsWith("/admin/login");
      const isAuthEntry = url.includes("/auth/login") || url.includes("/auth/logout");
      if (onAdmin && !onLogin && !isAuthEntry) {
        _redirecting = true;
        setAuthHeader(null);
        try { sessionStorage.setItem("lecis_session_expired", "1"); } catch {}
        window.location.replace("/admin/login");
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return err?.message || "Something went wrong.";
}

export function money(n) {
  const v = Number(n || 0);
  return v.toLocaleString("en-US", { style: "currency", currency: "USD" });
}
